import { SetRoutes } from 'components';
import routes from './routes';

const ChooseCompanyPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ChooseCompanyPage;
